/* eslint-disable @typescript-eslint/no-loss-of-precision */
import * as React from 'react';
import { Numberbox } from 'ui';
import { ScreenFieldProps, ScreenPicker } from 'app/area/codetable/item/screen-renderer/types';
import { ReadOnlyType } from 'app/area/codetable/item/types';
import { SafetyLimit } from 'app/area/codetable/item/types-store';
import { createSafetyLimitId } from 'app/area/codetable/item/codetable-item-helpers';

export interface SafetyLimitMinValueProps extends ScreenFieldProps {
  value: number;
  onChange: (value: number) => void;
  safetyLimit: SafetyLimit;
  required?: boolean;
}

export const SafetyLimitMinValue = ({ onChange, translation, readOnlyConfig, validation, value, safetyLimit, required }:
  SafetyLimitMinValueProps) => {

  const validationError = validation[createSafetyLimitId(ScreenPicker.minValue, safetyLimit?.application?.value)];

  const readOnly = readOnlyConfig && readOnlyConfig[ReadOnlyType.all];
  const isRequired = !readOnly && required;

  return <div className="col-lg-6 col-sm-12">
    <Numberbox
      componentId="safety_limit_min_value"
      readOnly={readOnly}
      label={translation ? { text: translation.min_value } : undefined}
      value={value}
      onChange={onChange}
      useThousand=" "
      minValue={-999999999999999.999999999999999}
      maxValue={999999999999999.999999999999999}
      maxDecimals={15}
      validation={isRequired && validationError}
      required={isRequired}
      textInvalidRangeError={translation.min_max_value_error_message}
    />
  </div>;
};
